import React from 'react';
import { css } from 'aphrodite';
import styles from './site-search-styles';
import {FaSearch} from 'react-icons/fa';

const SiteSearchView = (props) => (
  <div className={css(styles.root)}>
    <FaSearch className={css(styles.icon)} />
    <input spellCheck="false" className={css(styles.input)} placeholder={`Search ${props.title.toLowerCase()}`} />
  </div>
);

export default SiteSearchView;



// WEBPACK FOOTER //
// ./src/components/layout/site-search-view.js